import React from 'react';

import BulletListStyled from '../../asset/styled/component/BulletListStyled';

/**
 * 불릿 리스트 컴포넌트
 * @param {string} markerColor - 마커 색상 (예: 'var(--GrayScale-900)')
 * @param {string} textAlign - 텍스트 정렬 (예: 'left', 'center')
 * @param {boolean} flexColumn - flex column 적용 여부
 * @param {React.ReactNode} children - 리스트 아이템들
 */
const BulletList = ({ markerColor, textAlign, flexColumn = false, children, ...props }) => {
  return (
    <BulletListStyled
      $markerColor={markerColor}
      $textAlign={textAlign}
      $flexColumn={flexColumn}
      {...props}>
      {children}
    </BulletListStyled>
  );
};

export default BulletList;
